// extracted by mini-css-extract-plugin
module.exports = {"h2":"H2-module--h2--1B5nz"};